import {BaseEvent} from "./BaseEvent";

export class ExportChartEvent extends BaseEvent {
  public static NAME = 'exportChart';
  value: string;

  constructor(format: string) {
    super(ExportChartEvent.NAME);
    this.value = format;
  }
}
